const consentStorageKeys = [
    'marketingConsent',
    'cookieConsent',
    'cookie_consent',
    'CookieConsent',
    'cookiesAccepted'
];

const parseConsentValue = (value) => {
    if (!value) return false;
    const normalized = String(value).toLowerCase();
    if (['true', 'yes', 'accepted', 'all'].includes(normalized)) return true;
    return normalized.includes('marketing') && !normalized.includes('marketing:false');
};

export const hasMarketingConsent = () => {
    if (typeof window === 'undefined') return false;
    if (window.Cookiebot?.consent?.marketing) return true;
    if (window.OnetrustActiveGroups?.includes?.('C0004')) return true;

    return consentStorageKeys.some((key) => parseConsentValue(window.localStorage.getItem(key)));
};

export const loadMetaPixel = (pixelId) => {
    if (typeof window === 'undefined' || !pixelId || !hasMarketingConsent()) return false;
    if (window.fbq) return true;

    /* eslint-disable */
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
    n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */

    window.fbq('init', pixelId);
    return true;
};

export const trackMetaEvent = ({ pixelId, eventName, params = {}, eventId }) => {
    if (!loadMetaPixel(pixelId)) return false;
    if (eventId) {
        window.fbq('track', eventName, params, { eventID: eventId });
    } else {
        window.fbq('track', eventName, params);
    }
    return true;
};

export const storePendingPurchase = (type, data) => {
    try { sessionStorage.setItem(`meta_pending_${type}`, JSON.stringify(data)); } catch(e) {}
};

export const retrievePendingPurchase = (type) => {
    try {
        const raw = sessionStorage.getItem(`meta_pending_${type}`);
        if (raw) { sessionStorage.removeItem(`meta_pending_${type}`); return JSON.parse(raw); }
    } catch(e) {}
    return null;
};
